import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { formatViews } from '@/lib/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 影视海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/95 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {movie.type}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-background-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {movie.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-background-950/80 to-transparent px-2 pb-1.5 pt-6 text-[11px] text-background-100">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line"></i>
            {formatViews(movie.views)}
          </span>
          <span>{movie.year}</span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-700 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1 flex flex-wrap gap-1 text-[11px] text-foreground-500">
          <span>{movie.genre}</span>
          <span>·</span>
          <span>{movie.region}</span>
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900">
            {movie.duration}
          </span>
        </div>
      </div>
    </Link>
  );
}